import { Localization } from "@egencia/ege-js-shared-libs";
const hasWindow = typeof window === "object";
export class BackwardCompatibleLocalization extends Localization {
  formatDate(date, options) {
    if (!date || isNaN(date.getTime()))
      return options?.invalidText ?? "";
    const formatter = this.dateTimeFormatters[options?.dateFormat ?? "short"];
    if (!formatter) {
      throw new Error(`invalid dateFormat passed to formatDateTime: ${options?.dateFormat}`);
    }
    return formatter(date);
  }
  formatText(key, ...args) {
    const curatedArgs = !args ? [] : args.map((arg) => (arg ?? "").toString()).concat([]);
    if ((!this.localizations || Object.keys(this.localizations).length === 0) && hasWindow && window.uitk) {
      return window.uitk.i18n.msg(key, ...curatedArgs, {});
    }
    return super.formatText(key, ...args);
  }
}
